import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Spinner,
} from "reactstrap";
import CommonTableIndexWise from "../../../../../Components/Common/CommonTableIndexWise";
import {
  formatDate,
  GetUserData,
  showToastMessage,
} from "../../../../../common/service/CommonService";
import styles from "modules/Volunteer/VolunteerTest/css/volunteerTest.module.scss";
import AddAlcoholTestModal from "../../../VolunteerTest/components/AddAlcoholTestModal";
import AddMedicalTestModal from "../components/AddMedicalTestModal";
import VerifyLabTestModal from "../components/VerifyLabTestModal";
import DeleteModal from "../../../../../Components/Common/DeleteModal";
import FilePreviewModal from "../../../../Study/Attachments/components/FilePreviewModal";
import { useLabTestsService } from "../api/useStudyScreeningTests";
import { useVolunteerTest } from "../../../VolunteerTest/api/useVolunteerTest";
import { queryClient } from "../../../../../api/queryClient";
import sf from "assets/scss/common/searchFilter.module.scss";
import { PERMISSION_ACTIONS, PERMISSION_MODULES } from "../../../../../common/constants/PermissionConstants";
import { useAuditService } from "modules/Audit/api/useAuditQuery";
import { StudyTest, testConfig } from "../helper/studytest.constant";
import { TestType } from "../helper/studytest.types";
import { AlcoholResult_OPTIONS, loadCodelistsDetailId } from "api/modules/common.option";
import { STUDY_PATHS } from "Routes/paths";
import { BreadcrumbContext } from "Layouts/Header";
import CommonButton from "Components/Common/CommonButton";

export interface StudyTestListProps {
  readonly?: boolean;
}

const StudyTestList: React.FC<StudyTestListProps> = ({ readonly }) => {
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [selectedTest, setSelectedTest] = useState<TestType>("alcohol");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isMedicalModalOpen, setIsMedicalModalOpen] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);

  const [alcoholTestsData, setalcoholTestsData] = useState<any[]>([]);
  const [labTestsData, setlabTestsData] = useState<any[]>([]);
  const [ecgTestsData, setecgTestsData] = useState<any[]>([]);
  const [xrayTestsData, setxrayTestsData] = useState<any[]>([]);

  useEffect(()=>{
    loadCodelistsDetailId(["AlcoholResult_OPTIONS"])
  },[])

  const config = testConfig(
    AlcoholResult_OPTIONS,
    alcoholTestsData,
    ecgTestsData,
    labTestsData,
    xrayTestsData,
  );

  const currentTest = selectedTest ? config[selectedTest] : null;
  const [previewFile, setPreviewFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState<any>(null);
  const [showReason, setShowReason] = useState(false);
  const [perpagedata, setPerPageData] = useState(5);

  const [searchText, setSearchText] = useState<string | null>(null);
  const [editData, setEditData] = useState<any>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isPreviewAudit, setIsPreviewAudit] = useState(false);
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [selectedVerifyRecord, setSelectedVerifyRecord] = useState<any>(null);
  const [verifyError, setVerifyError] = useState(false);

  const studyId = Number(sessionStorage.getItem("activestudyid"));
  const volunteerId = Number(sessionStorage.getItem("activevolunteerid"));

  const breadcrumbContext = useContext(BreadcrumbContext);
  const setBreadcrumbItems = breadcrumbContext?.setBreadcrumbItems;

  useEffect(() => {
    setBreadcrumbItems?.([
      { text: "Study Screening", link: STUDY_PATHS.SCREENING_LIST },
      { text: "Study Tests" },
    ]);

    return () => {
      setBreadcrumbItems?.([]);
    };
  }, []);

  // Audit logic
  const { SelectAllMutation: AuditMutation } = useAuditService();
  const onAuditClick = () => {
    let payload = {};
    if(selectedTest === "lab"){
      payload = {
        modulename: "Study Lab Test",
        studyid: studyId,
        refid: volunteerId,
      }
    }
    else if(selectedTest === "alcohol"){
      payload = {
        modulename: "Study Alcohol Test",
        refid: volunteerId,
        studyid: studyId,
      }
    }

    AuditMutation.mutate(payload, {
      onSuccess: (data: any) => {
        if (data instanceof Blob) {
          const pdfFile = new File([data], "Study_Lab_Test_Audit_Log.pdf", {
            type: "application/pdf",
          });
          setIsPreviewAudit(true);
          setPreviewFile(pdfFile);
          setPreviewUrl(null);
          setIsPreviewOpen(true);
        }
      },
      onError: (error: any) => {
        showToastMessage("error", "Error fetching audit logs");
        console.error("Error fetching audit logs:", error);
      },
    });
  };

  // Alcohol test API (uses volunteer test API with stage=Study)
  const {
    SelectAllVolunteerTestResult: AlcoholSelectAll,
    DeleteMutation: AlcoholDeleteMutation,
  } = useVolunteerTest({
    volunteerid: volunteerId,
    currentpage: currentPageNumber,
    pagesize: perpagedata,
    searchtext: searchText,
    studyid: studyId,
    enabled:selectedTest === "alcohol",
  });

  const { VolunteerTestCount } = useVolunteerTest({
    volunteerid: volunteerId,
    studyid: studyId,
    enabled: !!volunteerId && !!studyId,
  });

  const testCounts = VolunteerTestCount.data?.data?.[0] || {};

  const { data: alcoholData, isFetching: alcoholFetching } = AlcoholSelectAll as {
    data?: any;
    isFetching: boolean;
  };

  useEffect(() => {
    if (alcoholData?.data) {
      setalcoholTestsData(alcoholData.data);
    } else {
      setalcoholTestsData([]);
    }
  }, [alcoholData]);

  // Lab test API
  const { SelectAllQuery, DeleteMutation, VerifyLabTestMutation } = useLabTestsService({
    searchText,
    studyid: studyId,
    volunteerid: volunteerId,
    pageNumber: currentPageNumber,
    pageSize: perpagedata,
    enabled: selectedTest === "lab",
  });

  const { data, isFetching } = SelectAllQuery as {
    data?: any;
    isFetching: boolean;
  };

 
  const API_FILE_BASE_URL =  sessionStorage.getItem("filebaseUrl") || process.env.REACT_APP_FILE_BASE_URL
    const BASE_URL = API_FILE_BASE_URL;
  const labData = SelectAllQuery.data?.data?.map((item: any) => ({
    ...item,
    testdate: formatDate(item.testdate),
    attachmentUrl: BASE_URL + item.filepath,
  }));

  const handleView = (row: any) => {
    setIsPreviewAudit(false);
    if (row.attachment instanceof File) {
      setPreviewFile(row.attachment);
      setPreviewUrl(null);
      setIsPreviewOpen(true);
    } else if (row.filepath || row.previewUrl) {
      const path = String(row.filepath || row.previewUrl);
      const url = path.startsWith("blob:") || path.startsWith("http://") || path.startsWith("https://")
        ? path
        : BASE_URL + path;
      setPreviewFile(null);
      setPreviewUrl(url);
      setIsPreviewOpen(true);
    }
  };

  const handleDownload = async (row: any) => {
    if (row.attachment instanceof File) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(row.attachment);
      link.download = row.attachment.name || "file";
      link.click();
      URL.revokeObjectURL(link.href);
      return;
    }

    if (!row.filepath && !row.previewUrl) return;

    const path = row.filepath || row.previewUrl;
    const url = (typeof path === "string" && (path.startsWith("blob:") || path.startsWith("http://") || path.startsWith("https://")))
      ? path
      : BASE_URL + path;

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = row.filename || row.testname || "file";
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (e) {
      console.error("Download failed", e);
    }
  };

  const handleFinalDelete = (id: any, reason: string) => {
    if (selectedTest === "alcohol") {
      // Use volunteer test delete API for alcohol tests
      AlcoholDeleteMutation.mutate(
        {
          alcoholtestid: id,
          volunteerid: volunteerId,
          studyid: studyId,
          updatedby: GetUserData()?.userid,
          updatedreason: reason,
          modulename: "Study Alcohol Test"
        },
        {
          onSuccess: (res: any) => {
            queryClient.invalidateQueries({ queryKey: ["volunteer-alcohol-test-result"] });
            queryClient.invalidateQueries({ queryKey: ["volunteer-test-count"] });
            showToastMessage("success", res?.message || "Deleted successfully");
            setShowReason(false);
            setIsDeleteOpen(false);
            setCurrentPageNumber(1);
          },
          onError: (error: any) => {
            showToastMessage("error", error?.message || "Delete failed");
          },
        },
      );
    } else if (selectedTest === "lab") {
      // Use lab test delete API for lab tests
      DeleteMutation.mutate(
        {
          studylabtestid: id,
          studyid: studyId,
          volunteerid: volunteerId,
          updatereason: reason,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["lab-tests-selectAll"] });
            queryClient.invalidateQueries({ queryKey: ["volunteer-test-count"] });
            queryClient.invalidateQueries({ queryKey: ["verification-notification-count"] });
            showToastMessage("success", `Record deleted successfully!`);
            setShowReason(false);
            setIsDeleteOpen(false);
            setCurrentPageNumber(1);
          },
          onError: (error: any) => {
            showToastMessage("error", error.message);
          },
        },
      );
    } else if (selectedTest === "ecg") {
      setecgTestsData((prev: any[]) => prev.filter((item) => item.id !== deleteRow?.id));
      showToastMessage("success", "ECG record deleted successfully!");
      setShowReason(false);
      setIsDeleteOpen(false);
    } else if (selectedTest === "xray") {
      setxrayTestsData((prev: any[]) => prev.filter((item) => item.id !== deleteRow?.id));
      showToastMessage("success", "X-Ray record deleted successfully!");
      setShowReason(false);
      setIsDeleteOpen(false);
    }
  };

  const handleVerifySubmit = (password: string, decision: "Pass" | "Fail") => {
    if (!selectedVerifyRecord) return;
    VerifyLabTestMutation.mutate(
      {
        verifypin: password,
        studylabtestid: Number(selectedVerifyRecord.studylabtestid),
        studyid: Number(studyId),
        volunteerid: Number(volunteerId),
        verifystatus: decision,
        verifiedby: Number(GetUserData()?.userid),
      },
      {
        onSuccess: (res: any) => {
          showToastMessage("success", res.message || "Record verified successfully");
          queryClient.invalidateQueries({ queryKey: ["lab-tests-selectAll"] });
          queryClient.invalidateQueries({ queryKey: ["volunteer-test-count"] });
          queryClient.invalidateQueries({ queryKey: ["verification-notification-count"] });
          setVerifyModalOpen(false);
          setSelectedVerifyRecord(null);
        },
        onError: (err: any) => {
          setVerifyError(true);
          showToastMessage("error", err.message || "Verification failed");
        },
      }
    );
  };

  const onSearch = (text: string | null) => {
    if (text !== null && text !== undefined) {
      setSearchText(text);
      setCurrentPageNumber(1);
    }
  };

  const handleCloseMedicalModal = () => {
    setIsMedicalModalOpen(false);
    setIsEditMode(false);
    setEditData(null);
  };

  const totalRecords =
    Array.isArray(data?.data) && data.data.length > 0
      ? (data.data[0].total_count ?? 0)
       :Array.isArray(alcoholData?.data) && alcoholData.data.length > 0
      ? (alcoholData.data[0].labtestcount ?? 0)
      : 0;
      
  const alcoholTotalRecords =
    Array.isArray(alcoholData?.data) && alcoholData.data.length > 0
      ? (alcoholData.data[0].totalcount ?? 0)
      : Array.isArray(labData?.data) && labData.data.length > 0
      ? (labData.data[0].alcoholtestcount ?? 0)
      : 0;

  useEffect(() => {
    setCurrentPageNumber(1);
  }, [searchText]);

  const [hoveredCard, setHoveredCard] = useState<string | null>(null);

  return (
    <Container fluid className="px-0">
      {/* ================= CARD VIEW ================= */}

      <Row className="g-3">
        {isFetching || alcoholFetching || VolunteerTestCount.isFetching
          ? Array.from({ length: 4 }).map((_, i) => (
              <Col md={3} key={i}>
                <Card className={styles.test_card}>
                  <CardBody className="text-center p-4">
                    <div className="placeholder-glow">
                      <div
                        className={`${styles.test_icon_wrap} placeholder`}
                        style={{ backgroundColor: "#e9ecef" }}
                      ></div>
                    </div>
                    <div className="placeholder-glow mt-3">
                      <span className="placeholder col-8 rounded"></span>
                    </div>
                    <div className="placeholder-glow mt-2">
                      <span className="placeholder col-4 rounded"></span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          : StudyTest.map((test) => {
              const testCount =
                test.key === "alcohol"
                  ? (testCounts.study_alcohol_count ?? 0)
                  : test.key === "ecg"
                    ? ecgTestsData.length
                    : test.key === "xray"
                      ? xrayTestsData.length
                      : test.key === "lab"
                        ? (testCounts.study_labtest_count ?? 0)
                        : 0;

              const getColors = (key: string) => {
                switch (key) {
                  case "alcohol":
                    return { 
                      bg: "#eff6ff", 
                      text: "#2563eb", 
                      grad: "linear-gradient(135deg, #ffffff 40%, #e0f2fe 100%)",
                      watermark: "ri-flask-line"
                    };
                  case "ecg":
                    return { 
                      bg: "#fffbeb", 
                      text: "#d97706", 
                      grad: "linear-gradient(135deg, #ffffff 40%, #fef3c7 100%)",
                      watermark: "ri-pulse-line"
                    };
                  case "lab":
                    return { 
                      bg: "#ecfdf5", 
                      text: "#059669", 
                      grad: "linear-gradient(135deg, #ffffff 40%, #d1fae5 100%)",
                      watermark: "ri-test-tube-line"
                    };
                  case "xray":
                    return { 
                      bg: "#f5f3ff", 
                      text: "#7c3aed", 
                      grad: "linear-gradient(135deg, #ffffff 40%, #ede9fe 100%)",
                      watermark: "ri-lungs-line"
                    };
                  default:
                    return { 
                      bg: "#f8f9fa", 
                      text: "#6c757d", 
                      grad: "#ffffff",
                      watermark: test.icon
                    };
                }
              };
              const colors = getColors(test.key);
              const isActive = selectedTest === test.key;
              const isHovered = hoveredCard === test.key;

              return (
                <Col md={3} key={test.key}>
                  <Card
                    className="border-0 rounded-4 position-relative overflow-hidden transition-all"
                    style={{
                      cursor: "pointer",
                      boxShadow: isActive
                        ? "0 4px 15px rgba(0,0,0,0.06)"
                        : isHovered
                          ? "0 8px 20px rgba(0,0,0,0.08)"
                          : "0 2px 8px rgba(0,0,0,0.02)",
                      outline: isActive
                        ? `1.5px solid ${colors.text}`
                        : isHovered
                          ? `1px solid ${colors.text}50`
                          : "1px solid #f1f5f9",
                      background: colors.grad,
                      transform: isHovered ? "translateY(-4px)" : "translateY(0)",
                      transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                    onClick={() => {
                      setSelectedTest(test.key);
                      setCurrentPageNumber(1);
                    }}
                    onMouseEnter={() => setHoveredCard(test.key)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <CardBody
                      className="p-3 d-flex flex-column justify-content-between"
                      style={{ minHeight: "140px", zIndex: 2 }}
                    >
                      {/* Background watermark icon */}
                      <div
                        style={{
                          position: "absolute",
                          right: "15px",
                          bottom: "5px",
                          opacity: isHovered ? 0.18 : 0.08,
                          pointerEvents: "none",
                          color: colors.text,
                          fontSize: "80px",
                          lineHeight: "1",
                          zIndex: 1,
                          transform: isHovered ? "scale(1.1) translate(4px, -4px)" : "scale(1)",
                          transition: "all 0.4s ease",
                        }}
                      >
                        <i className={`${colors.watermark} d-inline-block`}></i>
                      </div>

                      <div className="d-flex align-items-center gap-2 mb-3 position-relative" style={{ zIndex: 2 }}>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "44px",
                            height: "44px",
                            backgroundColor: colors.bg,
                            borderRadius: "12px",
                            transform: isHovered ? "scale(1.05)" : "scale(1)",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <i
                            className={`${test.icon} fs-4`}
                            style={{ color: colors.text }}
                          ></i>
                        </div>
                        <h6 className="mb-0 fw-bold text-dark fs-14 ms-2">
                          {test.name}
                        </h6>
                      </div>

                      <div className="d-flex justify-content-between align-items-end mt-1 position-relative" style={{ zIndex: 2 }}>
                        <div>
                          <h3
                            className="mb-0 fw-bold"
                            style={{ color: colors.text, fontSize: "28px", lineHeight: "1" }}
                          >
                            {testCount}
                          </h3>
                          <span className="text-muted fs-12 fw-medium mt-1 d-block">Records</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
      </Row>

      {/* ================= TABLE VIEW ================= */}
      {selectedTest && (
        <Card className="table_wrapper mt-3 border-0 shadow-sm rounded-4">
          <CardBody className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="mb-0 fw-bold text-dark d-flex align-items-center gap-2 fs-16">
                <i className="ri-list-check fs-5 text-primary"></i>
                {StudyTest.find((t) => t.key === selectedTest)?.name} Records
              </h5>
              <div className="d-flex align-items-center gap-3">
                <div
                  className={`${sf.searchBox} ${searchFocused ? sf.focused : ""}`}
                >
                  <i className={`ri-search-line ${sf.searchIcon}`} />
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchText ?? ""}
                    className={sf.searchInput}
                    onChange={(e) => onSearch(e.target.value)}
                    onFocus={() => setSearchFocused(true)}
                    onBlur={() => setSearchFocused(false)}
                  />
                  {searchText && (
                    <i
                      className={`ri-close-line ${sf.clearIcon}`}
                      onClick={() => onSearch("")}
                    />
                  )}
                </div>
                 {!readonly && (selectedTest === "lab" || selectedTest === "alcohol") && (
                  <CommonButton
                    module={PERMISSION_MODULES.STUDY_SCREENING}
                    action={selectedTest === "alcohol" ? PERMISSION_ACTIONS.ALCOHOLTEST_AUDIT : PERMISSION_ACTIONS.LABTEST_AUDIT}
                    color="primary"
                    className="px-3"
                    onClick={onAuditClick}
                    disabled={AuditMutation.isPending}
                    outline
                  >
                    {AuditMutation.isPending ? (
                      <Spinner size="sm" className="me-2" />
                    ) : (
                      <i className="ri-history-line me-1"></i>
                    )}
                    Audit
                  </CommonButton>
                )}
                {!readonly && (
                  <CommonButton
                    module={PERMISSION_MODULES.STUDY_SCREENING}
                    action={selectedTest === "alcohol" ? PERMISSION_ACTIONS.ALCOHOLTEST_ADD : PERMISSION_ACTIONS.LABTEST_ADD}
                    color="primary"
                    outline
                    onClick={() => {
                      if (selectedTest === "alcohol") {
                        setIsAddModalOpen(true);
                      } else {
                        setIsMedicalModalOpen(true);
                      }
                    }}
                  >
                    <i className="ri-add-line fs-15 me-1"></i> Add
                  </CommonButton>
                )}
              </div>
            </div>

            {currentTest ? (
              <CommonTableIndexWise
                moduleName={`${PERMISSION_MODULES.STUDY_SCREENING}:${selectedTest === "alcohol" ? "ALCOHOLTEST" : "LABTEST"}`}
                columns={currentTest.columns}
                data={selectedTest === "lab" ? labData || [] : currentTest.data}
                actions={(row) => {
                  if (readonly) {
                    return {
                      ...(selectedTest !== "alcohol" && {
                        onView: (r) => handleView(r),
                        onDownload: (r) => handleDownload(r),
                      }),
                    };
                  }

                  const isLab = selectedTest === "lab";
                  const showEdit = isLab ? !row.isverified : true;
                  const showDelete = isLab ? !row.isverified : true;
                  const showVerify = isLab ? !row.isverified : false;

                  return {
                    ...(selectedTest !== "alcohol" && {
                      onView: (r) => handleView(r),
                      onDownload: (r) => handleDownload(r),
                    }),
                    ...(showEdit && {
                      onEdit: (r) => {
                        setEditData(r);
                        setIsEditMode(true);
                        if (selectedTest === "alcohol") {
                          setIsAddModalOpen(true);
                        } else {
                          setIsMedicalModalOpen(true);
                        }
                      },
                    }),
                    ...(showDelete && {
                      onDelete: (r) => {
                        setDeleteRow(r);
                        setIsDeleteOpen(true);
                      },
                    }),
                    ...(showVerify && {
                      onVerify: (r) => {
                        setSelectedVerifyRecord(r);
                        setVerifyError(false);
                        setVerifyModalOpen(true);
                      },
                    }),
                  };
                }}
                loading={selectedTest === "alcohol" ? alcoholFetching : (selectedTest === "lab" ? isFetching : false)}
                pageSize={5}
                currentPage={currentPageNumber}
                onPageChange={setCurrentPageNumber}
                totalRecords={
                  selectedTest === "alcohol"
                    ? alcoholTotalRecords 
                    : selectedTest === "lab"
                      ? totalRecords
                      : selectedTest === "ecg"
                        ? ecgTestsData.length
                        : selectedTest === "xray"
                          ? xrayTestsData.length
                          : 0
                }
              />
            ) : (
              <div className="py-5 text-center text-muted">
                <i className="ri-folder-info-line fs-1 text-secondary opacity-50 mb-3 d-block"></i>
                <h5>
                  No {StudyTest.find((t) => t.key === selectedTest)?.name} table
                  configured yet
                </h5>
                <p>Click the add button to enter new records.</p>
              </div>
            )}
          </CardBody>
        </Card>
      )}

      {/* ================= ADD TEST MODAL ================= */}
      <AddAlcoholTestModal
        isOpen={isAddModalOpen}
        toggle={() => {
          setIsAddModalOpen(false);
          setIsEditMode(false);
          setEditData(null);
        }}
        editData={editData}
        isEditMode={isEditMode}
        volunteerid={volunteerId}
        studyid={studyId}
        alcoholstage="Study"
        modulename="Study Alcohol Test"
      />
      {selectedTest !== "alcohol" && (
        <AddMedicalTestModal
          isOpen={isMedicalModalOpen}
          toggle={handleCloseMedicalModal}
          testType={selectedTest}
          editData={editData}
          isEditMode={isEditMode}
          testTitle={
            StudyTest.find((t) => t.key === selectedTest)?.name || "Medical"
          }
          onSave={(data) => {
            const hasNewFile = data.attachment instanceof File;
            const keepExistingFile = isEditMode && editData && data.hasExistingFile !== false;

            let fileObj = null;
            let fileName = "No File";
            let previewUrl: string | null = null;

            if (hasNewFile) {
              fileObj = data.attachment;
              fileName = data.attachment.name;
              previewUrl = URL.createObjectURL(data.attachment);
            } else if (keepExistingFile) {
              fileObj = editData.attachment instanceof File ? editData.attachment : null;
              fileName = editData.filename || editData.testname || (fileObj ? fileObj.name : "No File");
              previewUrl = editData.filepath || editData.previewUrl || (fileObj ? URL.createObjectURL(fileObj) : null);
            }

            const formatted = {
              id: isEditMode && editData?.id ? editData.id : crypto.randomUUID(),
              testname: fileName,
              filename: fileName,
              filepath: previewUrl,
              previewUrl: previewUrl,
              remarks: data.remarks,
              lastmodifiedby: GetUserData()?.username || "Admin",
              lastmodifieddate: formatDate(String(new Date())),
              attachment: fileObj,
              testdate: formatDate(String(data.testdate || new Date())),
            };

            if (isEditMode && editData?.id) {
              if (selectedTest === "ecg") {
                setecgTestsData((prev: any[]) =>
                  prev.map((item) => (item.id === editData.id ? { ...item, ...formatted } : item))
                );
              } else if (selectedTest === "xray") {
                setxrayTestsData((prev: any[]) =>
                  prev.map((item) => (item.id === editData.id ? { ...item, ...formatted } : item))
                );
              }
            } else {
              if (selectedTest === "ecg") {
                setecgTestsData((prev: any[]) => [formatted, ...prev]);
              } else if (selectedTest === "xray") {
                setxrayTestsData((prev: any[]) => [formatted, ...prev]);
              }
            }

            handleCloseMedicalModal();
          }}
        />
      )}
      <FilePreviewModal
        file={previewFile}
        fileUrl={previewUrl}
        isOpen={isPreviewOpen}
        size={isPreviewAudit ? "xl" : undefined}
        onClose={() => {
          setIsPreviewOpen(false);
          setPreviewFile(null);
          setPreviewUrl(null);
        }}
      />

      <DeleteModal
        isopen={isDeleteOpen}
        recordId={deleteRow?.studylabtestid || deleteRow?.id || deleteRow?.alcoholtestid}
        recordName={
          deleteRow?.reportname || deleteRow?.testname || deleteRow?.bac
        }
        toggle={() => setIsDeleteOpen(false)}
        showDeleteReason={showReason}
        toggleDeleteReason={() => {
          setShowReason((prev) => !prev);
          setIsDeleteOpen(false);
        }}
        onDeleteClick={({ id, reason }) => {
          handleFinalDelete(id as number, reason);
        }}
        isLoading={selectedTest === "alcohol" ? AlcoholDeleteMutation.isPending : (selectedTest === "lab" ? DeleteMutation.isPending : false)}
      />

      <VerifyLabTestModal
        isOpen={verifyModalOpen}
        toggle={() => setVerifyModalOpen(false)}
        onVerify={handleVerifySubmit}
        isLoading={VerifyLabTestMutation.isPending}
        title="Verify Lab Test Record"
        recordName={selectedVerifyRecord?.reportname}
        isInvalid={verifyError}
      />
    </Container>
  );
};

export default StudyTestList;
